import {
  IImportSrtPayload,
  SubtitleActionTypes,
  IDeleteLanguagePayload,
  IDeleteLanguageSuccessPayload,
} from './types'

export const importSrt = (payload: IImportSrtPayload) => ({
  type: SubtitleActionTypes.IMPORT_SRT,
  payload,
})

export const importSrtSuccess = () => ({
  type: SubtitleActionTypes.IMPORT_SRT_SUCCESS,
})

export const importSrtFailure = () => ({
  type: SubtitleActionTypes.IMPORT_SRT_FAILURE,
})

export const deleteLanguage = (payload: IDeleteLanguagePayload) => ({
  type: SubtitleActionTypes.DELETE_LANGUAGE,
  payload,
})

export const deleteLanguageSuccess = (payload: IDeleteLanguageSuccessPayload) => ({
  type: SubtitleActionTypes.DELETE_LANGUAGE_SUCCESS,
  payload,
})

export const deleteLanguageFailure = () => ({
  type: SubtitleActionTypes.DELETE_LANGUAGE_FAILURE,
})
